import { useLazyQuery } from "@apollo/client";
import { Button } from "../../../../components/ui";
import { formatWarehouseDescription } from "./formatWarehouseDescription";
import { FETCH_WAREHOUSE_ITEMS_V2 as fetchWarehouseItemsV2 } from "../../../../graphql/query/WarehouseItem";

const CopyWarehouseDescription = ({ closeModal, instanceId, instance }) => {
  const [fetchWarehouseItems, { loading }] = useLazyQuery(
    fetchWarehouseItemsV2({
      // WarehouseItem scalar fields
      dimh: true,
      dimw: true,
      dimd: true,
      // WarehouseItem associations
      category: {
        description: true,
      },
      instance: {
        description: true,
      },
    }),
    {
      variables: {
        input: {
          _instance: {
            id: {
              operator: "eq",
              value: instanceId || instance?.id,
            },
          },
        },
      },
    },
  );

  const handleCopyWarehouseDescription = async () => {
    const { data } = await fetchWarehouseItems();
    const warehouseItems = data?.warehouseItemsV2?.edges || [];

    if (warehouseItems.length === 0) {
      closeModal();
      return;
    }

    const formattedDescription = formatWarehouseDescription(warehouseItems);
    await navigator.clipboard.writeText(formattedDescription);
    closeModal();
  };

  return (
    <div className="mt-4 flex">
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        autoFocus
        disabled={loading}
        loading={loading}
        label={"Copy Warehouse Description"}
        onClick={handleCopyWarehouseDescription}
      />
    </div>
  );
};

export default CopyWarehouseDescription;
